import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css'; // Importe o arquivo index.css aqui

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
